module.exports = __webpack_public_path__ + "img/shop1-4.37efca5b.png";